<div class="ui-g-12 ui-fluid mobile-filter">
  <div class="ui-g-12">
    <label
      class="mobile-filter-label"
      [translate]="'OPMONITORING.LABEL.LOG_ID'"
    ></label>
  </div>
  <div class="ui-g-12">
    <input pInputText type="text" [(ngModel)]="logId" />
  </div>
  <div class="ui-g-12">
    <label
      class="mobile-filter-label"
      [translate]="'LOCATION.LABEL.FACILITY_NAME'"
    ></label>
  </div>
  <div class="ui-g-12">
    <input pInputText type="text" [(ngModel)]="facilityName" />
  </div>
  <div class="ui-g-12">
    <label
      class="mobile-filter-label"
      [translate]="'OPMONITORING.LABEL.STATUS'"
    ></label>
  </div>
  <div class="ui-g-12">
    <input pInputText type="text" [(ngModel)]="statusName" />
  </div>

  <div class="ui-g-12">
    <button
      type="button"
      pButton
      icon="fa fa-search"
      iconPos="left"
      label="{{ 'COMMON.LABEL.BUTTONS.RETRIEVE' | translate }}"
      class="nav-button filter-panel-button"
      (click)="mobileFilter()"
    ></button>
  </div>
  <div class="ui-g-12">
    <button
      type="button"
      pButton
      icon="fa fa-fw fa-eraser"
      iconPos="left"
      label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
      class="nav-button filter-panel-button"
      (click)="clear()"
    ></button>
  </div>
</div>
